import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <nav aria-label="面包屑" className="container-site py-4">
      <ol className="flex flex-wrap items-center gap-1.5 text-xs md:text-sm text-foreground-600">
        <li>
          <Link
            to="/"
            className="inline-flex items-center gap-1 whitespace-nowrap hover:text-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-home-4-line text-sm" aria-hidden="true" />
            <span>首页</span>
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={`${item.label}-${index}`} className="flex items-center gap-1.5">
            <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true" />
            {item.to && index < items.length - 1 ? (
              <Link
                to={item.to}
                className="whitespace-nowrap hover:text-primary-600 transition-colors cursor-pointer"
              >
                {item.label}
              </Link>
            ) : (
              <span className="whitespace-nowrap text-foreground-950 font-medium" aria-current="page">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}